import _ from 'lodash'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import UserList from './component'
import { actions, selectors, getAttributes } from '../../imports'
import {
    // Actions
    setServerOrder,

    // Selectors
    getPlayText,
    getPlayTooltipText,
    getAddAccountText,
    getAddAccountTooltipText,
    getActiveMultiStart,
    getActiveOrder,
} from '../../data'

const getActiveProcesses = createSelector(
    [selectors.getActiveRunningProcesses, selectors.getActiveRunningLaunchProgresses],
    (running, starting) => _.union(running, starting),
)

const getInactiveMultiLaunchIds = createSelector(
    [getActiveMultiStart, getActiveProcesses],
    (multiLaunchIds, activeIds) =>
        // return all ids in multiLaunchIds that are not in activeIds
        _.difference(multiLaunchIds, activeIds),
)

// todo: find a better name for this
// Returns all ids that are marked for multilaunch, but are not active
const getIdsToStart = createSelector(
    [getActiveOrder, getInactiveMultiLaunchIds],
    (orderedIds, inactiveMultiLaunchIds) =>
        // return all ids that are in both arrays
        _.intersection(orderedIds, inactiveMultiLaunchIds),
)

// todo: find a better name for this
// If only one user is logged in it is returned based on its running state,
// otherwise returns getIdsToStart
// So basically this gives you list of all available users for the play button
const getAvailableIds = createSelector(
    [getActiveOrder, getIdsToStart, getActiveProcesses],
    (orderedIds, idsToStart, activeIds) => {
        // if only one user is logged in
        if (orderedIds.length === 1) {
            // If it is running, don't include it
            if (activeIds.length === 1) return []
            return orderedIds
        }

        return idsToStart
    },
)

/* eslint-disable */
function uuidv4() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16),
    )
}
/* eslint-enable */

const getSsoHost = (server, locale) => {
    if (
        server == null ||
        _.isEmpty(server) ||
        locale == null ||
        server.sso == null ||
        server.sso.url == null
    ) {
        return { host: '', locale: '', state: '' }
    }

    return {
        host: server.sso.url,
        locale,
        state: uuidv4(),
    }
}

function mapStateToProps(state) {
    const { app } = state
    const locale = selectors.getLocale(state)
    const attributes = getAttributes(locale)

    const autoLaunch = selectors.getAutoLaunchOnStartup(state)
    const autoLaunchOnStartup = app.autoRunEnabled && autoLaunch
    const thirdPartyLogin = attributes.thirdPartyLogin

    const ssoData = getSsoHost(selectors.getActiveServer(state), locale)

    return {
        layout: selectors.getLayout(state),
        serverId: selectors.getActiveServerId(state),
        availableIds: getAvailableIds(state),
        sortedUserIds: getActiveOrder(state),
        launchDelay: selectors.getLaunchDelay(state),
        playEnabled: selectors.getActivePlayable(state),
        pressDelayMilliseconds: attributes.pressDelayMilliseconds,
        autoLaunchOnStartup,
        tooltips: {
            play: getPlayTooltipText(state),
            addAccount: getAddAccountTooltipText(state),
        },
        playText: getPlayText(state),
        addAccountText: getAddAccountText(state),
        eulaStatus: selectors.getEulaStatus(state),
        thirdPartyLogin,
        ssoData,
        deviceId: selectors.getDeviceId(state),
    }
}

const setOrder = order => (dispatch, getState) => {
    const serverId = selectors.getActiveServerId(getState())
    dispatch(setServerOrder(serverId, order))
}

function mapDispatchToProps(dispatch) {
    return {
        setOrder: (order) => {
            dispatch(setOrder(order))
        },
        disableAutoRun: () => {
            dispatch(actions.disableAutoRun())
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(UserList)



// WEBPACK FOOTER //
// ./src/features/Users/components/UserList/index.js